import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'
import { KemLogo } from '@/assets/icons'

export const ChooseMethodHeader: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <>
      <BaseView row align="center" gap={6}>
        <KemLogo size={28} color={theme.colors.label.default} />
        <BaseText fontSize={22} fontFamily="bold" color="label.default">
          Kem
        </BaseText>
      </BaseView>

      <BaseView gap={14}>
        <BaseText color="label.default" fontSize={16} fontFamily="regular">
          {t('screens:identificationMethod.title')}
        </BaseText>

        <BaseText fontSize={30} fontFamily="semibold" color="label.default">
          {t('screens:identificationMethod.subtitle')}
        </BaseText>
      </BaseView>
    </>
  )
}
